import { render } from "./modal-messaggio-task.vue?vue&type=template&id=247699b2"
import script from "./modal-messaggio-task.vue?vue&type=script&lang=js"
export * from "./modal-messaggio-task.vue?vue&type=script&lang=js"

import "./modal-messaggio-task.vue?vue&type=style&index=0&id=247699b2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__